import classes from './EggyScore.module.scss'
import { Eggy } from '@eggplant/pattern-library'

export interface Props{
  rating: number
}

const FADED_OPACITY = '0.25'

const halfEggy =
  <span className={classes.wrapperStyle}>
    <span className={classes.lighterHalf}>
      <Eggy />
    </span>
    <span className={classes.darkerHalf}>
      <Eggy />
    </span>
  </span>

const getEggys = (rating: number) =>
  Array(5).fill(null).map((_item, index) => {
    const isFull = rating - index >= 1

    const isHalf = rating - index >= 0.5 && rating - index < 1

    return (
      <span
        className={classes.eggySpaces}
        key={index}
        style={
          {
            opacity: isFull || isHalf
              ? 1
              : FADED_OPACITY
          }
        }
      >
        {
          isHalf
            ? halfEggy
            : <Eggy />
        }
      </span>
    )
  })

const EggyScore = ({ rating }: Props) =>
  <div
    className={classes.EggyScore}
    title={`Rating: ${rating.toFixed(1)}`}
  >
    <span className={classes.header}>Eggy Score</span>
    {getEggys(rating)}
  </div>

export default EggyScore
